import React from "react";
import { useAuth } from "../features/auth/components/AuthProvider";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function Topbar() {
  const { user, rol } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
      alert("Error al cerrar sesión. Por favor, intenta nuevamente.");
    }
  }

  return (
    <header className="flex items-center justify-between bg-blue-50 border-b px-8 h-16">
      <div className="font-bold text-blue-900 text-lg">Panel {rol === "admin" ? "Administrador" : "Empresa"}</div>
      <div className="flex items-center gap-4">
        <span className="text-blue-800">{user?.email}</span>
        <button
          onClick={handleLogout}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors flex items-center gap-2 text-sm font-medium"
          title="Cerrar sesión"
        >
          <span>🚪</span>
          <span>Cerrar Sesión</span>
        </button>
      </div>
    </header>
  );
}